import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-download-app',
  standalone: true,
  imports: [],
  templateUrl: './download-app.component.html',
  styleUrl: './download-app.component.css'
})
export class DownloadAppComponent implements OnInit {

  constructor() {};

  ngOnInit(): void {
    this.redirectToStore();
  }

  redirectToStore(): void {
    const userAgent = navigator.userAgent || navigator.vendor;
    const isOpera = (window as any).opera; // Opera check
    const isMSStream = (window as any).MSStream; // MSStream check
  
    if (/android/i.test(userAgent)) {
      // Redirect to Google Play Store
      window.location.href = "https://play.google.com/store/apps/details?id=com.finig.nonghyup";
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !isMSStream) {
      // Redirect to Apple App Store
      window.location.href = "https://apps.apple.com/kh/app/nh-finance/id1624001084";
    } else if (isOpera) {
      // Handle Opera or other scenarios
      document.body.innerHTML = "Opera browser detected.";
    } else {
      // Optionally handle other devices or show a message
      document.body.innerHTML = "Please visit this link on your mobile device to download the app.";
    }
  }

}
